import decodeJwt from 'jwt-decode'
import queryClient from '../../queryClient'
import localStorageIds, { ORG_SCOPED_LOCAL_STORAGE_KEYS } from '../constants/localStorageIds'
import { removeLocalStorageValue, setLocalStorageValue } from './localStorageHelperMethods'
import loadAccess from './loadAccess'

// Single entry point for establishing a logged-in session from an auth
// response, shared by the credentials and SSO login paths. Clearing the query
// cache FIRST is load-bearing: the QueryClient outlives SPA session changes,
// so any cached query would otherwise serve the previous identity's data to
// the new session.
const startSession = async (data) => {
  queryClient.clear()

  const { isSuperAdmin } = decodeJwt(data?.accessToken)
  setLocalStorageValue([
    { id: localStorageIds.TOKEN, value: data.accessToken },
    { id: localStorageIds.INVITATIONS_SNACK_OPEN, value: false },
    {
      id: localStorageIds.IS_SUPER_ADMIN,
      value: JSON.parse(isSuperAdmin?.toLowerCase()),
    },
  ])

  // startSession is the funnel for every login path (credentials + SSO) and
  // also covers re-login after token expiry, where logout() never ran. Clear
  // the previous session's org-scoped selections so the new identity never
  // inherits a federation it can't access.
  removeLocalStorageValue([
    localStorageIds.USER_INITIAL_UNCONFIRMED_EMAIL,
    localStorageIds.IMPERSONATION,
    // The previous identity's; loadAccess refills them for this one.
    localStorageIds.ADDONS,
    localStorageIds.USER_ORG_ROLES,
    localStorageIds.ORG_PERMISSIONS,
    localStorageIds.COMPETITION_PERMISSIONS,
    ...ORG_SCOPED_LOCAL_STORAGE_KEYS,
  ])

  await loadAccess()

  // Dispatching for the components that listening storage event.
  window.dispatchEvent(new Event('storage'))
}

export default startSession
